import React, { useEffect, useState } from 'react';
import { Upload, QRCode , Avatar, Modal, Form, Tooltip, Button, Card,  Input, Select, Steps, Typography, Rate, Divider, Radio, InputNumber, message, Collapse, Tag, Progress } from 'antd';
import ReactPlayer from 'react-player';
import style from "./main.css"
import { Space } from 'antd';

import UploadFileToS3 from "../../funcs/s3Upload";

import {
  InstagramOutlined,
  FacebookOutlined,
  LinkedinOutlined,
  TwitterOutlined,
  BookOutlined, PlayCircleOutlined, ClockCircleOutlined,
  QuestionCircleOutlined,
  CheckCircleOutlined,
  GiftOutlined,
  DollarOutlined,
  CreditCardOutlined,
  CopyOutlined,
  BankOutlined,
  InboxOutlined,
  SyncOutlined

} from '@ant-design/icons';

import { v4 as uuidv4 } from 'uuid';
import { collection, doc, getDoc, getDocs, setDoc } from 'firebase/firestore';
import { fireDB } from '../../funcs/firebase';
const { Panel } = Collapse;

const { Step } = Steps;
const { Title, Paragraph } = Typography;
const { Option } = Select;
const { Text } = Typography;


const socialIcons = {
  instagram: { icon: <InstagramOutlined />, color: '#E1306C' },
  facebook: { icon: <FacebookOutlined />, color: '#1877F2' },
  linkedin: { icon: <LinkedinOutlined />, color: '#0A66C2' },
  twitter: { icon: <TwitterOutlined />, color: '#1DA1F2' },
};


const handleMediaUpload = async ({file, product_id,messageApi, uploadStatus,setURL}) => {
    
    
    let media_id = uuidv4();//generate random id;
    let media_type = file.name.split('.').pop(); //get media type from file
    let url = await UploadFileToS3(messageApi,file, product_id,media_id,media_type, uploadStatus);
    if(setURL){
        setURL(url)
    }
    return url
}   


const CheckoutModal = ({
  visible,
  onClose,
  pricing,
  courseData,
  onApplyCoupon,
  onCheckout,
}) => {
  const {
    pricingType,
    regularPrice,
    offerPrice,
    minPrice,
    suggestedPrice,
    gstEnabled,
  } = pricing;

  const [customPrice, setCustomPrice] = useState(suggestedPrice || minPrice);
  const [coupon, setCoupon] = useState('');
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [finalPrice, setFinalPrice] = useState(offerPrice || regularPrice);
  const [isApplying, setIsApplying] = useState(false);

  const isUserDecide = pricingType === 'user_decide';

  const handleCouponApply = async () => {
    if (!coupon) return;
    setIsApplying(true);
    try {
      const res = await onApplyCoupon(coupon);
      if (res.valid) {
        setFinalPrice(res.discountedPrice);
        setAppliedCoupon(coupon);
        message.success('🎉 Coupon applied successfully!');
      } else {
        message.error('❌ Invalid coupon');
      }
    } catch {
      message.error('❌ Failed to validate coupon');
    } finally {
      setIsApplying(false);
    }
  };

  const handlePayment = () => {
    const amount = isUserDecide ? customPrice : finalPrice;
    onCheckout(amount, appliedCoupon);
  };

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      title={<><CreditCardOutlined style={{ marginRight: 8 }} />Checkout</>}
      destroyOnClose
    >
      <Space direction="vertical" style={{ width: '100%' }}>

        <Divider style={{ margin: '12px 0' }} />

        {isUserDecide ? (
          <>
            <Text strong>
              <DollarOutlined style={{ marginRight: 6 }} />
              Set your price
            </Text>
            <Input
              type="number"
              min={minPrice}
              value={customPrice}
              onChange={(e) => setCustomPrice(Number(e.target.value))}
              addonBefore="₹"
              style={{ marginTop: 6 }}
            />
            <Text type="secondary">
              Minimum ₹{minPrice}, Suggested ₹{suggestedPrice}
            </Text>
          </>
        ) : (
          <>
            <Text strong>
              <CreditCardOutlined style={{ marginRight: 6 }} />
              Price Details
            </Text>
            <div>
              {offerPrice && offerPrice < regularPrice ? (
                <>
                  <Title level={3} style={{ margin: 0, color: '#52c41a' }}>
                    ₹{offerPrice}
                  </Title>
                  <Text delete type="secondary">
                    ₹{regularPrice}
                  </Text>
                </>
              ) : (
                <Title level={3} style={{ margin: 0 }}>₹{regularPrice}</Title>
              )}
            </div>

            {appliedCoupon && (
              <Tag icon={<CheckCircleOutlined />} color="success">
                Coupon "{appliedCoupon}" applied
              </Tag>
            )}

            <Input.Search
              placeholder="Enter coupon code"
              enterButton="Apply"
              loading={isApplying}
              value={coupon}
              onChange={(e) => setCoupon(e.target.value)}
              onSearch={handleCouponApply}
              style={{ marginTop: 10, textTransform: 'uppercase' }}
              prefix={<GiftOutlined />}
              disabled={!!appliedCoupon}
            />
          </>
        )}

        <Divider style={{ margin: '16px 0' }} />

        <Button
          type="primary"
          block
          size="large"
          onClick={handlePayment}
          icon={<CreditCardOutlined />}
        >
          Pay ₹{isUserDecide ? customPrice : finalPrice}
        </Button>
      </Space>
    </Modal>
  );
};


const AuthorsSection = ({ authors }) => {
  return (
    <div style={{ display: 'grid', gap: 32 }}>
      {authors.map((author, index) => (
        <div key={index} style={{
        boxShadow  : "0 4px 12px rgba(149, 149, 149, 0.21)",
        backgroundColor:"#ffffff",
        borderRadius: "12px",
        padding: "10px"
        }
        }>

          <div
            style={{
              width: '100%',
              height: 200,
              overflow: 'hidden',
              borderRadius: 12,
              marginBottom: 16,
            }}
          >
            <img
              src={author.imageUrl}
              alt={author.name}
              style={{ width: '100%', height: 'auto', }}
            />
          </div>

          <Text style={{ fontSize: 18, fontWeight: 700, color: '#1f1f1f', display: 'block' }}>
            {author.name}
          </Text>

          <Paragraph style={{ fontSize: 14, color: '#595959', marginTop: 4 }}>
            {author.description}
          </Paragraph>

          <Space size="large" style={{ marginTop: 8 }}>
            {Object.entries(author.socials || {}).map(([platform, link]) =>
              link ? (
                <a
                  key={platform}
                  href={link}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ fontSize: 20, color: socialIcons[platform]?.color }}
                >
                  {socialIcons[platform].icon}
                </a>
              ) : null
            )}
          </Space>
        </div>
      ))}
    </div>
  );
};


const MediaRenderer = ({ coverMedia }) => {
  const isVideo = /\.(mp4|webm|ogg)$/i.test(coverMedia); // Add formats as needed

  return isVideo ? (
    <ReactPlayer 
      url={coverMedia} 
      controls 
      width="100%" 
      height="auto"
      style={{borderRadius:"10px" }}
    />
  ) : (
    <img 
      src={coverMedia} 
      alt="cover media" 
      style={{ width: '100%', height: 'auto', borderRadius:"10px" }} 
    />
  );
};

const getCourseStats = (modules) => {
  let chapterCount = modules.length;
  let lessonCount = 0;
  let totalVideoDuration = 0;

  modules.forEach(module => {
    module.lessons.forEach(lesson => {
      lessonCount++;
      totalVideoDuration += lesson.videoDuration || 0;
    });
  });

  return { chapterCount, lessonCount, totalVideoDuration };
};

const formatDuration = (minutes) => {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return `${h ? `${h}h ` : ''}${m}m`;
};

const CourseStats = ({ modules }) => {
  const { chapterCount, lessonCount, totalVideoDuration } = getCourseStats(modules);

  return (
    <Space size="middle" style={{ marginTop: 8, marginBottom: 16 }}>
      <Text type="secondary" style={{ fontSize: 14 }}>
        <BookOutlined style={{ marginRight: 4 }} />
        {chapterCount} Chapters
      </Text>
      <Text type="secondary" style={{ fontSize: 14 }}>
        <PlayCircleOutlined style={{ marginRight: 4 }} />
        {lessonCount} Lessons
      </Text>
      <Text type="secondary" style={{ fontSize: 14 }}>
        <ClockCircleOutlined style={{ marginRight: 4 }} />
        {formatDuration(totalVideoDuration)}
      </Text>
    </Space>
  );
};

const TestimonialCard = ({ name, review, social, profilePicUrl }) => {

  const socialKey = social?.toLowerCase().replace("@","");
  const socialData = socialIcons[socialKey];


  return (
    <Card
      style={{
        borderRadius: 16,
        boxShadow: '0 4px 12px rgba(165, 165, 165, 0.06)',
        padding: 16,
        
        border: '1px solid rgba(165, 165, 165, 0.06)',
        marginBottom:"20px",
        width: "45%",
        maxWidth:"400px"
      }}
    >
       <div
        style={{
          position: 'absolute',
          top: 16,
          right: 16,
          fontSize: 24,
          color: socialData?.color,
          cursor: 'pointer',
        }}
      >
        {socialData?.icon}
        </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 4 }}>
        <Avatar size={48} src={profilePicUrl} />
        <div>
          <Text strong style={{ fontSize: 15 }}>{name}</Text>
          <br />
        </div>
      </div>

      <Paragraph style={{ fontSize: 15, color: '#111', lineHeight: 1.6 }}>
        {review}
      </Paragraph>
    </Card>
  );
};

const CourseContentRenderer = ({ modules }) => {
  return (
    <div style={{ marginTop: 24 }}>
      <Collapse
        accordion
        bordered={false}
        style={{ backgroundColor: '#fff', borderRadius: 12 }}
        defaultActiveKey={['0']}
      >
        {modules.map((module, moduleIndex) => (
          <Panel
            header={
              <Text style={{ fontSize: 18, fontWeight: 600, textTransform: 'capitalize'}}>
              {module.name}
              </Text>
            }
            key={moduleIndex}
            style={{
              backgroundColor: '#fafafa',
              borderRadius: 8,
              marginBottom: 12,
            }}
          >
            {module.lessons.map((lesson, lessonIndex) => {
              const lessonNumber = `${moduleIndex + 1}.${lessonIndex + 1}`;

              return (
                <div
                  key={lessonIndex}
                  style={{
                    padding: '12px 16px',
                    marginBottom: 10,
                    backgroundColor: '#f0f5ff',
                    borderRadius: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 6,
                  }}
                >
                  <Space align="center" wrap size="small">
                  
                    <Text style={{ fontSize: 18, fontWeight: 500 ,textTransform: 'capitalize'}}>
                      {lesson.name}
                    </Text>
                    {lesson.isFreePreview && (
                      <Tag color="green" style={{ fontSize: 14, borderRadius: 4 }}>
                        Free
                      </Tag>
                    )}
                  </Space>
                  <Space size="small">
                    <ClockCircleOutlined style={{ color: '#999' }} />
                    <Text type="secondary" style={{ fontSize: 14 }}>
                      {formatDuration(lesson.videoDuration || 0)}
                    </Text>
                  </Space>
                   {lesson.isFreePreview && lesson.videoLink && (
                  <ReactPlayer
                    url={lesson.videoLink}
                    controls
                    width="100%"
                    // height="auto"
                    style={{ borderRadius: 8, marginTop: 8 }}
                  />
                )}
                </div>
              );
            })}
          </Panel>
        ))}
      </Collapse>
    </div>
  );
};



const FAQSection = ({ faqs }) => {
  return (
    <div style={{ marginTop: 32 }}>
      <Collapse
        bordered={false}
        accordion
        style={{
          backgroundColor: '#fff',
          borderRadius: 12,
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
        }}
      >
        {faqs.map((faq, index) => (
          <Panel
            header={<Text strong>{faq.question}</Text>}
            key={index}
            style={{
              backgroundColor: '#f9f9f9',
              borderRadius: 8,
              marginBottom: 12,
            }}
          >
            <Text style={{ fontSize: 14 }}>{faq.answer}</Text>
          </Panel>
        ))}
      </Collapse>
    </div>
  );
};


const TypeformJoinFlow = ({setResponses ,fieldConfigs, setVisible, setCheckoutVisible}) => {
  
  const [currentStep, setCurrentStep] = useState(0);
  const [answers, setAnswers] = useState({});
  const [otpSent, setOtpSent] = useState(false);
  const [form] = Form.useForm();

  const currentField = fieldConfigs[currentStep];


 // save after 1s of inactivity


  const handleNext = async () => {
    try {
      const values = await form.validateFields();
      const answer = values[currentField.label];


      setAnswers({ ...answers, [currentField.label]: answer });
      form.resetFields();
      setOtpSent(false);

      if (currentStep + 1 < fieldConfigs.length) {
        setCurrentStep(currentStep + 1);
      } else {
        let answers_ = { ...answers, [currentField.label]: answer }
        setAnswers(answers_)
        setResponses(answers_)
        setVisible(false);
        setCurrentStep(0);
        setAnswers({});
        setCheckoutVisible(true)
      }
    } catch (err) {
      console.log('Validation failed', err);
    }
  };

  const renderField = () => {
    if (currentField.type === 'dropdown') {
      return (
        <Form.Item
          name={currentField.label}
          rules={[{ required: true, message: 'Please choose an option' }]}
        >
          <Select placeholder="Select an option">
            {currentField.options.map((opt) => (
              <Option key={opt} value={opt}>{opt}</Option>
            ))}
          </Select>
        </Form.Item>
      );
    } else {
      return (
        <Form.Item
          name={currentField.label}
          rules={[{ required: true, message: `Please enter ${currentField.label}` }]}
        >
          <Input
            type={currentField.type === 'number' ? 'number' : 'text'}
            placeholder={otpSent ? 'Enter OTP' : currentField.label}
          />
        </Form.Item>
      );
    }
  };

  return(
    <div>
    <Title level={4}>{currentField.label}</Title>
        <Form form={form} layout="vertical" onFinish={handleNext}>
          {renderField()}
           <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
            <Button color='default'  variant="solid" block onClick={handleNext}>
              {otpSent ? 'Verify OTP' : 'Next'}
            </Button>
          </div>
        </Form>
    </div>
  )
};


const PaymentModal = ({ setScreenShotURL, orderID ,productId, visible, onClose, courseName, amount, paymentPayload, onRazorpay, onManualConfirm, onPaymentDone}) => {
  const isUPI = paymentPayload?.type === 'wallet';
  const upiId = paymentPayload?.upi_id;
  const walletLink = paymentPayload?.wallet_link;
  const [screenshotFile, setScreenshotFile] = useState(null);
  const [current, setCurrent] = useState(0);
  const [uploadStatus, setUploadStatus] = useState()

  const handleCopy = () => {
    navigator.clipboard.writeText(upiId);
    message.success('UPI ID copied!');
  };

  const [isDesktop, setIsDesktop] = useState(true);

  useEffect(() => {
    const checkDevice = () => {
      setIsDesktop(window.innerWidth >= 768); // Customize threshold as needed
    };

    checkDevice();
    window.addEventListener('resize', checkDevice);
    return () => window.removeEventListener('resize', checkDevice);


  }, []);


  useEffect(() => {
    if(paymentPayload.type == "rzpay" && visible == true){
      let product = {
        notes : {"some":"data"},
        pay_to : "",
        final_price : amount
      }
      handleRZPayment(product)
    }
  }, [visible])

      const handleRZPayment = (product) => {
        if ( window.Razorpay) {
    
            try {
              let notes_b64 = btoa(JSON.stringify(product.notes));

              const options = {
                key: "rzp_live_JtjGCHjkESNzIZ", // Replace with your Razorpay key
                name: `${courseName}`,
                description: `Payment for ${product.product_title}`,
                amount:  product.final_price*100, // Amount in paise
                currency:"INR",
                
                handler: function (response) {
                  const BOT_TOKEN = "7755731503:AAE-tgVF31zgXE4cqcMqgFlKv7bsJGrF1-E";
                  const CHAT_ID = '776956029';
          
                  const url = `https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`;
                  
                  let tele_message = `✅ - Payment of __ ${product?.currency}${product.final_price} __ for __ ${product?.product_title} __ from __ https://instagram.com/${product?.notes?.from?.username} __ to insta id - https://instagram.com/${product.pay_to}. META - post_id ${product?.notes?.post_id} comment_id ${product?.notes?.comment_id}`
                  
                  let data = {
                      chat_id: CHAT_ID,
                      text: tele_message
                  };
          

                  fetch(url, {
                      method: 'POST',
                      headers: {
                          'Content-Type': 'application/json'
                      },
                      body: JSON.stringify(data)
                  })
                  .then(response => response.json())
                  .then(data => {
                      console.log('Message sent successfully:', data);
                  })
                  .catch(error => {
                      console.error('Error sending message:', error);
                  });
                  alert("Payment completed. You can close this page.");
                  if (product.redirect_url) {
                      window.location.href = product.redirect_url; // Redirect to the provided URL
                  } else {
                      setTimeout(() => {
                          window.close(); // Close the page after a short delay
                      }, 1000);
                  }
                },
                error: function (response) {
                  alert("Payment Failed, Please try again later!")
                },
                modal: {
                  ondismiss: function () {
                  alert("Payment Cancelled, Please try again!")
                  }
                },
                "notes": { "b64data" : notes_b64},
                theme: {
                  color: "black",
                },
              };

              // console.log("-=-=-=-btoa(product.notes)", notes_b64)
      
              const razorpayInstance = new window.Razorpay(options);
              razorpayInstance.open();
      
            } catch (error) {
              alert("Error loading Razorpay: " + error.message);
            } finally {
              // setLoading(false);
              onClose()
            }
      
          }
      
          else {
            alert("Please try again later...")
          }
    };



  const steps = [
    {
      title: 'Scan & Pay',
      content: (
        <Space direction="vertical" style={{ width: '100%' }}>
          {isDesktop ? (
            <>
              <Title level={5}>Step 1: Scan & Pay</Title>
              <QRCode
                value={`upi://pay?pa=${upiId}&pn=instantdm&am=${amount}&cu=INR&tn=${courseName}`}
                size={160}
              />
              <Divider>OR Use UPI ID</Divider>
            </>
          ) : (
            <Title level={5}>Step 1: Open your UPI & Pay ₹{amount}</Title>
          )}

          <Text style={{ fontSize: 16 }}>
            UPI ID: <b>{upiId}</b>
          </Text>
          <Text>Amount: ₹{amount}</Text>

          <Button
            style={{ marginTop: 12 }}
            onClick={handleCopy}
            block
          >
            Copy UPI ID
          </Button>

          <Button
            color='default'  variant="solid"
            block
            onClick={() => setCurrent(1)}
            style={{ marginTop: 16 }}
          >
            I’ve Paid via UPI
          </Button>
        </Space>
      )
    },
    {
      title: 'Confirm Payment',
      content: (
        <Space direction="vertical" style={{ width: '100%' }}>
          <Title level={5}>Step 2: Confirm Payment</Title>
          <Text type="secondary">
            Upload your payment screenshot so we can verify your payment and give access to your products.
          </Text>

          <Upload
            name="paymentScreenshot"
            listType="picture-card"
            maxCount={1}
            showUploadList={{ showRemoveIcon: true }}
            beforeUpload={() => false}
            onChange={({ file }) => {
              handleMediaUpload({file, "product_id":`${productId}_order_${orderID}`,"uploadStatus":setUploadStatus, setURL: (url) => {setScreenShotURL( (prev) => [...prev , url])}} ) }
            }
          >

          { (uploadStatus > 0 && uploadStatus < 100) && <Progress percent={uploadStatus}/> }

            <div>
              <InboxOutlined style={{ fontSize: 32, color: '#999' }} />
              <div style={{ marginTop: 8 }}>Upload Screenshot</div>
              
            </div>
          </Upload>

          <Button
            style={{
              color: 'white',
              backgroundColor: 'green',
              marginTop: 10
            }}
            icon={<CheckCircleOutlined />}
            block
            size="large"
            onClick={() => {
              message.success('We’ve received your confirmation. Verifying payment...');
              onManualConfirm();
              setCurrent(0); // reset for next time
              onPaymentDone();
              onClose();
            }}
          >
            Submit & Confirm
          </Button>

          <Button block onClick={() => setCurrent(0)}>
            Back
          </Button>
        </Space>
      )
    }
  ];

  return (
    <>
    { paymentPayload.type == "wallet" && <Modal
      open={visible}
      onCancel={() => {
        setCurrent(0);
        onClose();
      }}
      footer={null}
      title="Complete Your Payment"
      destroyOnClose
      className="custom-modal"
    >
      {isUPI ? (
        <>
          <Steps current={current} size="small" style={{ marginBottom: 24 }}>
            {steps.map((item) => (
              <Step key={item.title} title={item.title} />
            ))}
          </Steps>
          <div>{steps[current].content}</div>
        </>
      ) : (
        <Space direction="vertical" style={{ width: '100%' }}>
          <Title level={4}>Pay ₹{amount}</Title>
          <Text>Secure payment via Razorpay</Text>
          <Button
            type="primary"
            icon={<BankOutlined />}
            block
            size="large"
            onClick={() => onRazorpay(amount)}
          >
            Pay Now
          </Button>
        </Space>
      )}
    </Modal>
    }

    {
      paymentPayload.type == "rzpay" && <></>
    }

    
    </>
    

  );

};

const PriceCard = ({ pricing }) => {
  const { pricingType, regularPrice, offerPrice } = pricing;

  const hasDiscount = pricingType === 'fixed' && offerPrice < regularPrice;

  return (
      <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
    <Card
      bordered
      style={{ maxWidth: 300, textAlign: 'center' , border:"none"}}
      bodyStyle={{ padding: 20 }}
    >

      {hasDiscount ? (
        <>
          <Text type="secondary" delete style={{ fontSize: 16 }}>
            ₹{regularPrice}
          </Text>
          <br />
          <Title level={2} style={{ color: '#52c41a', margin: 0 }}>
            ₹{offerPrice}
          </Title>
          <Tag color="green" style={{ marginTop: 8 }}>
            Save ₹{regularPrice - offerPrice}
          </Tag>
        </>
      ) : (
        <Title level={2} style={{ margin: 0 }}>
          ₹{regularPrice}
        </Title>
      )}
    </Card>
    </div>
  );
};


const courseData = {
  "productId":"6cfb14f9-1fce-4b4d-b80f-50c2b8b2b560",
  "title": "sad asdsad",
  "coverMedia": "https://public-assets.instantdm.com/instantdm-shop/public/some-id/media/062de955-2028-47c6-a638-a75a623265eb.png",
  "description": "<p>hey there</p>",
  "cta": "Buy Now",
  "benefits": [
    "hello there"
  ],
  "testimonials": [],
  "faqs": [],
  "gallery": [],
  "authors": [],
  "customSection": "",
  "themeColor": "default",
  "modules": [],
  "validity": {
    "type": "lifetime",
    "limitValue": 1,
    "limitUnit": "months"
  },
  "pricing": {
    "pricingType": "fixed",
    "regularPrice": 1000,
    "offerPrice": 600,
  },
  "fields": [
    {
      "label": "Full Name",
      "type": "text",
      "isDefault": true
    },
    {
      "label": "Email",
      "type": "text",
      "isDefault": true,
      "verifyWithOTP": false
    },
    {
      "label": "Whatsapp Number",
      "type": "number",
      "isDefault": true,
      "verifyWithOTP": false
    }
  ],
  "coupons": [],
  "policies": {
    "terms": "",
    "refund": "",
    "privacy": ""
  }
}

const DigitalPurchaseFlow = () => {
  const [step, setStep] = useState(0);
  const [form] = Form.useForm();

  const [checkoutVisible, setCheckoutVisible] = useState(false)
  const [screenShotURL, setScreenShotURL] = useState([])

  const [responses, setResponses] = useState([])

  const [orderID, setOrderID] = useState()

  const [status, setStauts] = useState()

  const [loading, setLoading] = useState()

  const [paymentDone, setPaymentDone] = useState(false)

    useEffect(() => {
      let order_id = localStorage.getItem("orderID")
      if (!localStorage.getItem("orderID") ){
          order_id = uuidv4();
          setOrderID(order_id)
          localStorage.setItem("orderID", order_id)

      }
      else{
        setOrderID(order_id)

          const fetchPreviousOrders = async () => {
          try {
            const docRef = doc(fireDB, "dp-orders", courseData.productId,"orders",order_id );
            const docSnap = await getDoc(docRef);

            if (docSnap.exists()) {
                let fetched_data = docSnap.data()
                console.log("fetched_ata", fetched_data)

                if(fetched_data?.status == "completed"){

                }
                if (fetched_data?.status == "manual_verification_requried"){
                  setStauts(fetched_data?.status )
                }


              }

          } catch (err) {
            console.error("Error loading drafts", err);
            message.error("Failed to load drafts.");
          } finally {
            setLoading(false);
          }
        };

        fetchPreviousOrders();
      }
    },[])

    useEffect(() => {
      console.log("screenshot url" , screenShotURL)
    }, [screenShotURL])


    useEffect(() => {
      if(paymentDone){
        const saveDraft = async ()  => {
              try {
        
              const docRef = doc(fireDB, "dp-orders", courseData.productId,"orders",orderID );
             
              await setDoc(docRef, {
                orderID,
                product : courseData?.title,
                payment: payment_payload?.type,
                productId: courseData.productId,
                upi: {
                  id : payment_payload?.upi_id
                },
                fields : {
                  ...responses
                },
                price:{
                  amount : courseData?.pricing?.offerPrice,
                  currency : "INR"
                },
                screenshots : [...screenShotURL],
                status :  payment_payload?.type == "wallet" ? "manual_verification_requried" : "auto_verified",
                ordered_at : new Date(),
                varified_at :  payment_payload?.type == "wallet" ? "-" : new Date(),
                shared_at :  null,
              } , { merge: true });      
              
              } catch (error) {
                console.error("Error saving draft:", error);
              }
            }
            saveDraft()
      }
    },[paymentDone])

    const handleFinish = (values) => {
      console.log('User Data:', values);
      message.success('Info collected! Proceeding to payment.');
      setStep(2);
    };

    let payment_payload = {
      "type":"wallet", // rzpay , wallet
      "upi_id":"9626777690@upi",
      "rzpy_public":"rzp_live_JtjGCHjkESNzIZ"
    }


  const [visible, setVisible] = useState(false);

      useEffect(() => {
        const loadCheckoutScript = () => {
          return new Promise((resolve, reject) => {
            if (window.Razorpay) return resolve(true);
      
            const script = document.createElement('script');
            script.src = "https://checkout.razorpay.com/v1/checkout.js";
            script.onload = () => resolve(true);
            script.onerror = () => reject(new Error("Razorpay checkout script failed to load"));
            document.body.appendChild(script);
          });
        };
      
        loadCheckoutScript()
          .then(() => console.log("Razorpay checkout script loaded"))
          .catch((error) => console.error(error));
          
      }, []);

    useEffect(() => {
      console.log("-=-=-=-=-=srtsf", status)
    },[status])
  return (
    <div className={`main-content ${visible ? 'blur-overlay' : ''}`}  style={{ maxWidth: 600, margin: 'auto', marginBottom:"40px" , padding: 24, backgroundColor:"white", minHeight:"100vh"}}>
        <div className='header'><h3 style={{textAlign:"center"}}>{courseData.title}</h3></div>
        <MediaRenderer coverMedia={courseData.coverMedia} />

        <h3>{courseData.title}</h3>

        <PriceCard
          pricing={courseData.pricing}
        />

        
       { courseData.benefits.length > 0 && <>
        <h3>Benefits 🎉</h3>
        {
          courseData.benefits.map((item) => <p style={{fontSize:"18px"}}>✅{item}</p>)
        }
        <Divider/>
        </>}
        {
          courseData.description.length > 0 && <>
          <h3>Description</h3>
          <div dangerouslySetInnerHTML={{__html:courseData.description.replace('iframe width="640"', 'iframe width="100%"')}}/>
          <Divider />
          </>
        }
        
        { courseData.testimonials.length > 0 && <><h3>Reviews</h3>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 16,
            // justifyContent: 'fle',
          }}
        >
        {courseData.testimonials.map((t, i) => (
          <TestimonialCard
            key={i}
            name={t.name}
            review={t.review}
            social={`@${t.social}`}
            profilePicUrl={t.profilePicUrl}
          />
        ))}
        </div>
        </>
      }
      { courseData.authors.length > 0 && <>
        <h3>About Author</h3>
        <AuthorsSection authors={courseData.authors}  />
        </>
}

      { courseData.faqs.length > 0 && <>
        <h3>Common Questions</h3>
        <FAQSection faqs={courseData.faqs} />
      </>}

      
    { status != "manual_verification_requried" ? <Button 
         style={{
          position: 'fixed',
          bottom: 20,
          left: '50%',
          transform: 'translateX(-50%)',
          maxWidth: 600,
          width: '90%',
          zIndex: 1000,
        }}
        onClick={() =>    
          {
          if (courseData.fields.length < 0){
            setCheckoutVisible(true)
          }
          else{
            setVisible(true)
          }
        }
        }

        color={courseData.themeColor || "default"} variant="solid" className='sticky-btn  shake purchase-button' block size='large'>{courseData.cta || "Join Now"}</Button>
    
        : <Button 
         style={{
          position: 'fixed',
          bottom: 20,
          left: '50%',
          transform: 'translateX(-50%)',
          maxWidth: 600,
          width: '90%',
          zIndex: 1000,
        }}
        onClick={() =>    {}
        }

        loading={{ icon: <SyncOutlined spin /> }} className='sticky-btn' block size='large'>Verification Pending</Button>
    
      }
      <Modal
        open={visible}
        onCancel={() => setVisible(false)}
        footer={null}
        closable={false}
        destroyOnClose
        title={`${courseData.title}`}
        className="custom-modal"
      >
        <TypeformJoinFlow setResponses = {(answers) => setResponses(answers)} 
        fieldConfigs={courseData.fields} setVisible={setVisible}
        setCheckoutVisible = {setCheckoutVisible} />
      </Modal>

      <PaymentModal
      setScreenShotURL = {setScreenShotURL}
      productId = {courseData.productId}
      visible={checkoutVisible}
      onClose={() => setCheckoutVisible(false)}
      amount = {courseData.pricing.offerPrice}
      courseName={courseData.title}
      paymentPayload={payment_payload}
      onRazorpay={() => {console.log("payment razorpay")}}
      onManualConfirm={() => { setPaymentDone(true)}}
      onPaymentDone = { () => setPaymentDone(true)}
      orderID = {orderID}
      />

      <p className="watermark" style={{textAlign:"center"}}> <span style={{fontSize:"12px", color:"rgba(0,0,0,.4)"}}>Powered by ⚡ </span> <a href="https://instantdm.com">instantDM</a></p>
    </div>
  );
};

export default DigitalPurchaseFlow;